import type { LinkImportProvider } from '../api/linkImports';

export const LINK_IMPORT_PLATFORM_LABELS: Record<LinkImportProvider, string> = {
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  facebook: 'Facebook',
  x: 'X',
};

export const SUPPORTED_LINK_IMPORT_PLATFORMS: Array<{ provider: LinkImportProvider; label: string }> = [
  { provider: 'youtube', label: LINK_IMPORT_PLATFORM_LABELS.youtube },
  { provider: 'tiktok', label: LINK_IMPORT_PLATFORM_LABELS.tiktok },
  { provider: 'instagram', label: LINK_IMPORT_PLATFORM_LABELS.instagram },
  { provider: 'facebook', label: LINK_IMPORT_PLATFORM_LABELS.facebook },
  { provider: 'x', label: LINK_IMPORT_PLATFORM_LABELS.x },
];

export function isSupportedLinkImportUrl(value: string) {
  return detectLinkImportProvider(value) !== null;
}

export function detectLinkImportProvider(value: string): LinkImportProvider | null {
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    const host = url.hostname.toLowerCase();
    if (host === 'youtu.be' || host === 'youtube.com' || host.endsWith('.youtube.com')) return 'youtube';
    if (host === 'tiktok.com' || host.endsWith('.tiktok.com')) return 'tiktok';
    if (host === 'instagram.com' || host.endsWith('.instagram.com')) return 'instagram';
    if (
      host === 'facebook.com' ||
      host === 'fb.watch' ||
      host === 'facebookwatch.com' ||
      host.endsWith('.facebook.com')
    ) {
      return 'facebook';
    }
    if (host === 'x.com' || host.endsWith('.x.com') || host === 'twitter.com' || host.endsWith('.twitter.com')) return 'x';
    return null;
  } catch {
    return null;
  }
}

export function getLinkImportProviderLabel(provider?: LinkImportProvider | null) {
  return provider ? LINK_IMPORT_PLATFORM_LABELS[provider] ?? 'media' : 'media';
}
